import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	maintenanceEta: '',
	cookieConsent: null,
}

/* Store overall app current(Viewing) data */
const currentMixDataSlice = createSlice({
	name: 'currentMixData',
	initialState,
	reducers: {
		setCurrentMixData(state, { payload }) {
			return { ...state, ...payload }
		},
	},
})

export const { setCurrentMixData } = currentMixDataSlice.actions

export default currentMixDataSlice.reducer
